(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tjure-produktfinder"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('tjure-product-finder')) return;

  const answerOrder = ['name', 'age', 'topic', 'observations', 'format'];
  const exclusiveObservations = ['none', 'unsure'];
  const observations = {
    stomach: [
      ['grass', 'Grasfressen', 'Mein Hund frisst Gras.'],
      ['smacking', 'Häufiges Schmatzen', 'Mir fällt wiederholtes Schmatzen auf.'],
      ['lip_licking', 'Häufiges Lefzenlecken', 'Mein Hund leckt sich häufig über die Lefzen.'],
      ['surface_licking', 'Lecken an Böden oder Gegenständen', 'Gemeint ist das Lecken an Oberflächen, nicht an Pfoten oder Haut.']
    ],
    bowel: [
      ['scooting', 'Po-Rutschen', 'Mein Hund rutscht mit dem Hinterteil über den Boden.'],
      ['bowel_noise', 'Bauchgeräusche oder Blähungen', 'Ich bemerke Gluckern, Rumoren oder vermehrte Blähungen.'],
      ['soft_stool', 'Weicher Kot', 'Der Kot ist weicher als gewohnt.'],
      ['diarrhea', 'Aktueller Durchfall', 'Mein Hund hat gerade flüssigen oder sehr häufigen Kotabsatz.']
    ],
    calm: [
      ['noise', 'Reaktion auf Geräusche', 'Bestimmte Geräusche machen meinen Hund unruhig.'],
      ['alone', 'Unruhe beim Alleinbleiben', 'Allein findet mein Hund schwer zur Ruhe.'],
      ['travel', 'Unruhe auf Reisen', 'Fahrten oder fremde Umgebungen fallen meinem Hund schwer.'],
      ['changes', 'Unruhe bei Veränderungen', 'Veränderungen im Alltag beschäftigen meinen Hund.'],
      ['settling', 'Schwer zur Ruhe finden', 'Mein Hund wirkt häufig angespannt oder rastlos.']
    ],
    joints: [
      ['rising', 'Schwerer aufstehen', 'Das Aufstehen fällt meinem Hund schwerer.'],
      ['jumping', 'Ungern springen', 'Mein Hund vermeidet Sprünge, die er früher gemacht hat.'],
      ['short_walks', 'Kürzere Spaziergänge', 'Mein Hund möchte schneller wieder zurück.'],
      ['limping', 'Aktuelles Hinken oder Lahmen', 'Mein Hund belastet ein Bein nicht wie gewohnt.']
    ],
    skin: [
      ['dull_coat', 'Stumpfes Fell', 'Das Fell wirkt weniger glänzend als sonst.'],
      ['shedding', 'Fellwechsel', 'Mein Hund verliert im Fellwechsel viele Haare.'],
      ['scratching', 'Häufiges Kratzen', 'Mein Hund kratzt sich auffällig oft.'],
      ['paw_licking', 'Häufiges Pfotenlecken', 'Mein Hund leckt wiederholt an seinen Pfoten.']
    ]
  };
  const profileLabels = {
    stomach: 'Magen', bowel: 'Darm', anal: 'Analbereich',
    calm: 'Ruhe & Entspannung', joints: 'Gelenke & Bewegung', skin: 'Haut & Fell'
  };
  const baseQuestions = {
    name: {
      key: 'name', type: 'text', label: 'Dein Hund', title: 'Wie heißt Dein Hund?',
      description: 'Lass uns Deinen Hund kennenlernen.'
    },
    age: {
      key: 'age', label: 'Das Alter',
      description: 'Wähle die passende Altersgruppe.',
      options: [
        ['under_one', 'Unter 1 Jahr'],
        ['one_to_three', '1–3 Jahre'],
        ['four_to_seven', '4–7 Jahre'],
        ['eight_to_eleven', '8–11 Jahre'],
        ['twelve_plus', '12 Jahre oder älter'],
        ['unknown', 'Alter nicht genau bekannt']
      ]
    },
    topic: {
      key: 'topic', label: 'Dein Anliegen',
      description: 'Wähle einen Bereich. Danach kannst Du angeben, was Dir auffällt.',
      options: [
        ['gut', 'Magen & Darm', 'Fütterung, Bauch und Kotabsatz'],
        ['calm', 'Ruhe & Entspannung', 'Gelassenheit im Alltag'],
        ['joints', 'Gelenke & Bewegung', 'Aufstehen, Laufen und Bewegen'],
        ['skin', 'Haut & Fell', 'Fell, Haut und Pfoten']
      ]
    },
    format: {
      key: 'format', label: 'Die Fütterungsform',
      description: 'Welche Form möchtest Du Dir ansehen?',
      options: [
        ['liquid', 'Liquid', 'Eine flüssige Ergänzung'],
        ['tabs', 'Tabs', 'Eine Ergänzung in Tablettenform'],
        ['any', 'Beides ist möglich', 'Liquids, Tabs und passende Bundles vergleichen.']
      ]
    }
  };

  class TjureProductFinder extends HTMLElement {
    constructor() {
      super();
      this.state = { step: 0, answers: {}, result: null };
      this.controller = null;
      this.observer = null;
    }

    connectedCallback() {
      if (this.controller) return;
      if (this.querySelector('[data-tpf-ready]')) {
        this.mount();
      } else {
        this.observer = new MutationObserver(() => {
          if (this.querySelector('[data-tpf-ready]')) this.mount();
        });
        this.observer.observe(this, { childList: true, subtree: true });
      }
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.observer) this.observer.disconnect();
      this.controller = null;
      this.observer = null;
    }

    mount() {
      if (!this.isConnected || this.controller) return;
      if (this.observer) this.observer.disconnect();
      this.observer = null;
      const select = name => this.querySelector('[data-tpf-' + name + ']');
      this.ui = {
        app: select('app'), fallback: select('fallback'), step: select('step'),
        progress: select('progress'), fill: select('progress-fill'),
        questionPanel: select('question-panel'), question: select('question'),
        description: select('description'), options: select('options'),
        resultPanel: select('result-panel'), resultTitle: select('result-title'),
        resultDescription: select('result-description'), resultNote: select('result-note'),
        summary: select('summary'), summaryList: select('summary-list'), summaryContext: select('summary-context'),
        observationNote: select('observation-note'), products: select('products'), consultation: select('consultation'),
        announcement: select('announcement'),
        back: this.querySelector('[data-tpf-action="back"]'),
        skipName: this.querySelector('[data-tpf-action="skip-name"]'),
        next: this.querySelector('[data-tpf-action="next"]')
      };
      if (Object.entries(this.ui).some(([name, element]) => name !== 'consultation' && !element)) return;
      this.cards = Array.from(this.querySelectorAll('[data-tpf-product]'));
      this.controller = new AbortController();
      const listenerOptions = { signal: this.controller.signal };
      this.addEventListener('input', event => this.editName(event), listenerOptions);
      this.addEventListener('change', event => this.choose(event), listenerOptions);
      this.addEventListener('keydown', event => {
        const input = event.target;
        if (event.key !== 'Enter' || event.isComposing || !(input instanceof HTMLInputElement)) return;
        if (!input.hasAttribute('data-tpf-name') || !this.ui.options.contains(input) || this.state.result) return;
        event.preventDefault();
        this.editName(event);
        if (this.cleanName(input.value)) this.advance();
        else this.skipName();
      }, listenerOptions);
      this.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('[data-tpf-action]');
        if (!button || !this.contains(button) || button.disabled) return;
        if (button.dataset.tpfAction === 'back') this.previous();
        if (button.dataset.tpfAction === 'next') this.advance();
        if (button.dataset.tpfAction === 'skip-name') this.skipName();
      }, listenerOptions);
      this.addEventListener('shopify:block:select', event => {
        if (this.dataset.designMode !== 'true') return;
        const card = this.cards.find(item => item.dataset.blockId === event.detail?.blockId);
        if (card) this.showEditorProduct(card);
      }, listenerOptions);
      this.ui.app.hidden = false;
      this.ui.fallback.hidden = true;
      if (this.state.result?.kind === 'editor') {
        const card = this.cards.find(item => item.dataset.blockId === this.state.result.blockId);
        if (card) this.showEditorProduct(card, false);
        else this.restart(false);
      } else if (this.state.result) {
        this.showResult(this.state.result, false);
      } else {
        this.showQuestion(false);
      }
    }

    getSteps() {
      return answerOrder.slice();
    }

    cleanName(value) {
      return typeof value === 'string'
        ? value.replace(/[\u0000-\u001f\u007f]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 40).trimEnd()
        : '';
    }

    dogName(fallback = 'Dein Hund', answers = this.state.answers) {
      return this.cleanName(answers.name) || fallback;
    }

    getQuestion(key, answers = this.state.answers) {
      if (key === 'observations') {
        const isGut = answers.topic === 'gut';
        const items = isGut ? [...observations.stomach, ...observations.bowel] : observations[answers.topic] || [];
        return {
          key, label: 'Deine Beobachtungen', title: 'Was beobachtest Du bei ' + this.dogName('Deinem Hund', answers) + '?',
          multiple: true, description: 'Du kannst mehrere Felder anklicken.',
          groups: isGut ? [
            { title: 'Magen', options: observations.stomach },
            { title: 'Darm & Kotabsatz', options: observations.bowel }
          ] : [],
          options: [...items,
            ['none', 'Keine dieser Beobachtungen', 'Ich suche eine allgemeine Ergänzung für den Alltag.'],
            ['unsure', 'Ich kann es nicht sicher einschätzen', 'Ich möchte meine Beobachtungen erst genauer einordnen.']
          ]
        };
      }
      const question = baseQuestions[key];
      if (!question) return undefined;
      if (key === 'age') return { ...question, title: 'Wie alt ist ' + this.dogName('Dein Hund', answers) + '?' };
      if (key === 'topic') return { ...question, title: 'Um welchen Bereich geht es bei ' + this.dogName('Deinem Hund', answers) + '?' };
      if (key === 'format') return { ...question, title: 'Welche Fütterungsform passt für ' + this.dogName('Deinen Hund', answers) + '?' };
      return question;
    }

    hasAnswer(question, answers = this.state.answers) {
      if (!question) return false;
      const answer = answers[question.key];
      if (question.type === 'text') {
        return typeof answer === 'string' && answer.length <= 40 && answer === this.cleanName(answer);
      }
      const values = question.options.map(option => option[0]);
      if (!question.multiple) return values.includes(answer);
      return Array.isArray(answer) && answer.length > 0 && new Set(answer).size === answer.length &&
        answer.every(value => values.includes(value)) &&
        (!answer.some(value => exclusiveObservations.includes(value)) || answer.length === 1);
    }

    setAnswer(question, value, checked = true) {
      if (!question || !answerOrder.includes(question.key)) return false;
      const previous = this.state.answers[question.key];
      let answer = value;
      if (question.type === 'text') {
        if (typeof value !== 'string') return false;
        answer = this.cleanName(value);
      } else {
        if (!question.options.some(option => option[0] === value)) return false;
        if (question.multiple) {
          const selected = new Set(Array.isArray(previous) ? previous : []);
          if (!checked) selected.delete(value);
          else if (exclusiveObservations.includes(value)) {
            selected.clear();
            selected.add(value);
          } else {
            exclusiveObservations.forEach(item => selected.delete(item));
            selected.add(value);
          }
          answer = question.options.map(option => option[0]).filter(item => selected.has(item));
        }
      }
      if (JSON.stringify(previous) === JSON.stringify(answer)) return false;
      if (question.key === 'topic') {
        delete this.state.answers.observations;
        delete this.state.answers.format;
      }
      if (question.key === 'observations') delete this.state.answers.format;
      this.state.answers[question.key] = answer;
      this.state.result = null;
      return true;
    }

    editName(event) {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.hasAttribute('data-tpf-name')) return;
      if (this.state.result || this.getSteps()[this.state.step] !== 'name' || !this.ui.options.contains(input)) return;
      this.setAnswer(this.getQuestion('name'), input.value);
      this.ui.next.disabled = !this.cleanName(input.value);
    }

    skipName() {
      if (this.state.result || this.getSteps()[this.state.step] !== 'name') return;
      this.setAnswer(this.getQuestion('name'), '');
      this.advance();
    }

    choose(event) {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.hasAttribute('data-tpf-choice')) return;
      if (this.state.result || !this.ui.options.contains(input)) return;
      const question = this.getQuestion(this.getSteps()[this.state.step]);
      if (!question || question.type === 'text' || (!question.multiple && !input.checked)) return;
      this.setAnswer(question, input.value, input.checked);
      const answer = this.state.answers[question.key];
      this.ui.options.querySelectorAll('[data-tpf-choice]').forEach(item => {
        item.checked = question.multiple ? Boolean(answer?.includes(item.value)) : answer === item.value;
      });
      this.ui.next.disabled = !this.hasAnswer(question);
      if (question.multiple) {
        const count = Array.isArray(answer) ? answer.length : 0;
        this.ui.announcement.textContent = count + (count === 1 ? ' Angabe ausgewählt.' : ' Angaben ausgewählt.');
      }
    }

    updateQuestionProgress(question) {
      const total = this.getSteps().length;
      this.ui.step.textContent = 'Schritt ' + (this.state.step + 1) + ' von ' + total + ' · ' + question.label;
      this.setProgress(this.state.step + 1, total);
    }

    renderNameField() {
      const field = document.createElement('div');
      field.className = 'tpf__field';
      const label = document.createElement('label');
      label.className = 'tpf__field-label';
      label.htmlFor = this.id + '-name';
      label.textContent = 'Name Deines Hundes (optional)';
      const input = document.createElement('input');
      input.id = this.id + '-name';
      input.name = this.id + '-name';
      input.className = 'tpf__input';
      input.type = 'text';
      input.maxLength = 40;
      input.autocomplete = 'off';
      input.spellcheck = false;
      input.setAttribute('autocapitalize', 'words');
      input.setAttribute('enterkeyhint', 'next');
      input.setAttribute('data-tpf-name', '');
      input.value = this.cleanName(this.state.answers.name);
      const help = document.createElement('p');
      help.id = this.id + '-name-help';
      help.className = 'tpf__field-help';
      help.textContent = 'Maximal 40 Zeichen. Du kannst auch ohne Namen fortfahren.';
      input.setAttribute('aria-describedby', help.id);
      field.append(label, input, help);
      this.ui.options.append(field);
    }

    renderChoice(option, question, container) {
      const [value, title, help] = option;
      const label = document.createElement('label');
      label.className = 'tpf__option';
      const input = document.createElement('input');
      input.type = question.multiple ? 'checkbox' : 'radio';
      input.className = 'tpf__radio';
      input.name = this.id + '-' + question.key;
      input.value = value;
      input.setAttribute('data-tpf-choice', '');
      const answer = this.state.answers[question.key];
      input.checked = question.multiple ? Boolean(answer?.includes(value)) : answer === value;
      const text = document.createElement('span');
      text.className = 'tpf__option-text';
      const titleText = document.createElement('span');
      titleText.className = 'tpf__option-title';
      titleText.textContent = title;
      text.append(titleText);
      if (help) {
        const helpText = document.createElement('span');
        helpText.className = 'tpf__option-help';
        helpText.textContent = help;
        text.append(helpText);
      }
      label.append(input, text);
      container.append(label);
    }

    showQuestion(moveFocus = true) {
      this.state.result = null;
      const steps = this.getSteps();
      this.state.step = Math.max(0, Math.min(Number.isInteger(this.state.step) ? this.state.step : 0, steps.length - 1));
      const missing = steps.findIndex(key => !this.hasAnswer(this.getQuestion(key)));
      if (missing !== -1 && missing < this.state.step) this.state.step = missing;
      const question = this.getQuestion(steps[this.state.step]);
      this.ui.questionPanel.hidden = false;
      this.ui.resultPanel.hidden = true;
      this.cards.forEach(card => { card.hidden = true; });
      this.ui.question.textContent = question.title;
      this.ui.description.textContent = question.description;
      this.ui.options.replaceChildren();
      if (question.type === 'text') {
        this.renderNameField();
      } else {
        const grouped = new Set();
        (question.groups || []).forEach(group => {
          const fieldset = document.createElement('fieldset');
          fieldset.className = 'tpf__option-group';
          const legend = document.createElement('legend');
          legend.className = 'tpf__group-title';
          legend.textContent = group.title;
          const options = document.createElement('div');
          options.className = 'tpf__options';
          group.options.forEach(option => {
            grouped.add(option[0]);
            this.renderChoice(option, question, options);
          });
          fieldset.append(legend, options);
          this.ui.options.append(fieldset);
        });
        question.options.filter(option => !grouped.has(option[0])).forEach(option => this.renderChoice(option, question, this.ui.options));
      }
      this.updateQuestionProgress(question);
      this.ui.back.hidden = this.state.step === 0;
      this.ui.skipName.hidden = question.key !== 'name';
      this.ui.next.disabled = question.type === 'text' ? !this.cleanName(this.state.answers.name) : !this.hasAnswer(question);
      this.ui.next.textContent = this.state.step === steps.length - 1 ? 'Auswahl ansehen' : 'Weiter';
      this.ui.announcement.textContent = '';
      if (moveFocus) this.ui.question.focus();
    }

    profilesForAnswers(answers = this.state.answers) {
      const selected = answers.observations;
      if (!Array.isArray(selected) || selected.includes('unsure')) return [];
      if (!this.hasAnswer(this.getQuestion('observations', answers), answers)) return [];
      if (answers.topic !== 'gut') return ['calm', 'joints', 'skin'].includes(answers.topic) ? [answers.topic] : [];
      if (selected.includes('none')) return [];
      const profiles = [];
      if (observations.stomach.some(option => selected.includes(option[0]))) profiles.push('stomach');
      if (selected.includes('bowel_noise') || selected.includes('soft_stool')) profiles.push('bowel');
      if (selected.includes('scooting')) profiles.push('anal');
      return profiles;
    }

    routeDecision(upToKey = 'format') {
      const steps = this.getSteps();
      const last = steps.indexOf(upToKey);
      const observationStep = steps.indexOf('observations');
      if (last < observationStep) return null;
      if (!steps.slice(0, observationStep + 1).every(key => this.hasAnswer(this.getQuestion(key)))) return null;
      const selected = this.state.answers.observations;
      if (selected.includes('diarrhea')) return { kind: 'vet', reason: 'diarrhea' };
      if (selected.includes('limping')) return { kind: 'vet', reason: 'limping' };
      if (!this.profilesForAnswers().length) {
        return { kind: 'consult', reason: selected.includes('unsure') ? 'unsure' : 'no_gut_observation' };
      }
      if (last < steps.indexOf('format') || !this.hasAnswer(this.getQuestion('format'))) return null;
      return { kind: 'products', reason: 'matched_profiles' };
    }

    advance() {
      if (this.state.result) return this.restart();
      const steps = this.getSteps();
      if (!this.hasAnswer(this.getQuestion(steps[this.state.step]))) return;
      const route = this.routeDecision(steps[this.state.step]);
      if (route) return this.showResult(route);
      if (this.state.step < steps.length - 1) this.state.step += 1;
      this.showQuestion();
    }

    previous() {
      if (this.state.result?.kind === 'editor') return this.restart();
      if (!this.state.result) this.state.step = Math.max(0, this.state.step - 1);
      this.showQuestion();
    }

    restart(moveFocus = true) {
      this.state = { step: 0, answers: {}, result: null };
      this.showQuestion(moveFocus);
    }

    setProgress(value, total, finished = false) {
      this.ui.progress.setAttribute('aria-valuenow', String(value));
      this.ui.progress.setAttribute('aria-valuemax', String(total));
      this.ui.progress.setAttribute('aria-valuetext', finished ? 'Abgeschlossen' : 'Schritt ' + value + ' von ' + total);
      this.ui.fill.style.width = Math.round(value / total * 100) + '%';
    }

    matchingCards() {
      if (this.routeDecision()?.kind !== 'products') return [];
      const { topic, format } = this.state.answers;
      const profiles = this.profilesForAnswers();
      const candidates = this.cards.filter(card =>
        card.dataset.productId && card.dataset.topic === topic && profiles.includes(card.dataset.profile) &&
        ['liquid', 'tabs', 'mixed'].includes(card.dataset.format) &&
        (format === 'any' || card.dataset.format === format)
      );
      const selected = [];
      const seen = new Set();
      const represented = new Set();
      const add = card => {
        if (!card || selected.length >= 3 || seen.has(card.dataset.productId)) return;
        seen.add(card.dataset.productId);
        represented.add(card.dataset.profile);
        selected.push(card);
      };
      [true, false].forEach(available => {
        const tier = candidates.filter(card => (card.dataset.available === 'true') === available);
        const tierProfiles = [...new Set(tier.map(card => card.dataset.profile))].filter(profile => !represented.has(profile));
        const target = Math.min(3 - selected.length, tierProfiles.length);
        let best = [];
        // Mehrfach zugeordnete Produkte sollen kein anderes Profil verdrängen.
        const coverProfiles = (index, picks, used) => {
          if (picks.length > best.length) best = picks.slice();
          if (best.length === target || index >= tierProfiles.length || picks.length === target) return;
          for (const card of tier.filter(item => item.dataset.profile === tierProfiles[index])) {
            if (used.has(card.dataset.productId)) continue;
            used.add(card.dataset.productId);
            picks.push(card);
            coverProfiles(index + 1, picks, used);
            picks.pop();
            used.delete(card.dataset.productId);
            if (best.length === target) return;
          }
          coverProfiles(index + 1, picks, used);
        };
        coverProfiles(0, [], new Set(seen));
        best.forEach(add);
        tier.forEach(add);
      });
      return selected;
    }

    renderSummary(route) {
      const selected = this.state.answers.observations || [];
      this.ui.summaryList.replaceChildren();
      const matchingOptions = this.getQuestion('observations').options.filter(option => selected.includes(option[0]));
      matchingOptions.forEach(option => {
        const item = document.createElement('li');
        item.textContent = option[1];
        this.ui.summaryList.append(item);
      });
      this.ui.summary.hidden = matchingOptions.length === 0;
      const age = baseQuestions.age.options.find(option => option[0] === this.state.answers.age);
      const topic = baseQuestions.topic.options.find(option => option[0] === this.state.answers.topic);
      this.ui.summaryContext.textContent = [this.dogName(), age?.[1], topic?.[1]].filter(Boolean).join(' · ');
      let note = '';
      if (route.kind !== 'vet') {
        if (selected.includes('scooting')) {
          note = 'Po-Rutschen kann verschiedene Ursachen haben. Lass den Analbereich von ' + this.dogName('Deinem Hund') + ' tierärztlich prüfen.';
        } else if (selected.some(value => ['rising', 'jumping', 'short_walks'].includes(value))) {
          note = 'Veränderte Bewegungen können auf Beschwerden hinweisen. Lass die Ursache tierärztlich prüfen.';
        } else if (selected.some(value => ['scratching', 'paw_licking'].includes(value))) {
          note = 'Häufiges Kratzen oder Pfotenlecken kann verschiedene Ursachen haben. Lass die Ursache tierärztlich prüfen.';
        }
      }
      this.ui.observationNote.textContent = note;
      this.ui.observationNote.hidden = !note;
    }

    prepareResult() {
      this.ui.questionPanel.hidden = true;
      this.ui.resultPanel.hidden = false;
      this.ui.products.hidden = true;
      this.ui.summary.hidden = true;
      this.ui.observationNote.hidden = true;
      this.ui.resultNote.hidden = true;
      this.ui.resultNote.textContent = '';
      this.cards.forEach(card => { card.hidden = true; card.style.order = ''; });
      this.ui.skipName.hidden = true;
      this.ui.next.disabled = false;
    }

    showEditorProduct(card, scroll = true) {
      if (this.dataset.designMode !== 'true') return;
      this.state.result = { kind: 'editor', blockId: card.dataset.blockId };
      this.prepareResult();
      this.ui.products.hidden = false;
      card.hidden = false;
      this.ui.resultTitle.textContent = 'Vorschau des Produktblocks';
      const profile = profileLabels[card.dataset.profile];
      this.ui.resultDescription.textContent = profile
        ? 'Zuordnungsprofil: ' + profile + '. Diese Einzelvorschau erscheint nur im Theme-Editor; im Shop gilt der vollständige Fragenablauf.'
        : 'Dieses Produkt hat noch kein Zuordnungsprofil und erscheint deshalb nicht im Kundenergebnis. Wähle links das fachlich passende Profil.';
      if (this.ui.consultation) this.ui.consultation.hidden = true;
      this.ui.step.textContent = 'Vorschau im Theme-Editor';
      this.setProgress(1, 1, true);
      this.ui.back.hidden = true;
      this.ui.next.textContent = 'Fragenablauf starten';
      this.ui.announcement.textContent = 'Der ausgewählte Produktblock wird angezeigt.';
      if (scroll) card.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    }

    showResult(route, moveFocus = true) {
      route = this.routeDecision();
      if (!route) return this.showQuestion(moveFocus);
      this.state.result = route;
      this.prepareResult();
      this.renderSummary(route);
      if (this.ui.consultation) this.ui.consultation.hidden = route.kind === 'vet';
      let title;
      let description;
      let announcement = '';
      if (route.kind === 'vet') {
        title = 'Bitte lass das zuerst tierärztlich abklären.';
        description = route.reason === 'diarrhea'
          ? 'Bei aktuellem Durchfall kontaktiere bitte Deine Tierarztpraxis, bevor Du eine zusätzliche Ergänzung auswählst.'
          : 'Aktuelles Hinken oder Lahmen sollte tierärztlich untersucht werden, bevor Du eine zusätzliche Ergänzung auswählst.';
      } else if (route.kind === 'consult') {
        title = 'Wir helfen Dir persönlich weiter.';
        description = route.reason === 'unsure'
          ? 'Lass uns Deine Beobachtungen und die Fütterung persönlich besprechen. Wir helfen Dir gern bei der Orientierung im Sortiment.'
          : 'Damit wir Dir etwas Passendes aus unserem Sortiment zeigen können, lass uns Dein Anliegen und die Fütterung persönlich besprechen.';
      } else {
        const selectedCards = this.matchingCards();
        if (selectedCards.length) {
          title = 'Deine Produktauswahl für ' + this.dogName('Deinen Hund');
          description = 'Diese Sortimentsauswahl orientiert sich an Deinen Beobachtungen. Daraus lässt sich keine Ursache feststellen.';
          selectedCards.forEach((card, index) => { card.hidden = false; card.style.order = String(index); });
          this.ui.products.hidden = false;
          this.ui.resultNote.textContent = 'Die angezeigten Angebote sind Alternativen. Prüfe auf der Produktseite die Alterseignung, Zutaten und Fütterungshinweise aller enthaltenen Produkte. Bei Allergien oder Medikamenten stimme die Fütterung bitte mit Deiner Tierarztpraxis ab.';
          this.ui.resultNote.hidden = false;
          announcement = selectedCards.length + (selectedCards.length === 1 ? ' Produkt wird angezeigt.' : ' Produkte werden angezeigt.');
        } else {
          title = 'Wir helfen Dir persönlich weiter.';
          description = 'Zu Deiner Auswahl können wir Dir hier gerade kein Produkt anzeigen. Melde Dich gern bei uns, damit wir Deine Angaben und die Fütterung gemeinsam besprechen können.';
          announcement = 'Für diese Auswahl wird kein Produkt angezeigt.';
        }
      }
      this.ui.resultTitle.textContent = title;
      this.ui.resultDescription.textContent = description;
      this.ui.step.textContent = 'Dein Ergebnis';
      this.setProgress(this.getSteps().length, this.getSteps().length, true);
      this.ui.back.hidden = false;
      this.ui.next.textContent = 'Neu starten';
      this.ui.announcement.textContent = announcement;
      if (moveFocus) this.ui.resultTitle.focus();
    }
  }

  customElements.define('tjure-product-finder', TjureProductFinder);
})();

  } catch(e) { console.error(e); }
})();
})();
